import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';

// ===== Frankfurter Jobbörse für Naturwissenschaftler:innen =====

export const fjnRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::fjn',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new FJNStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(FJNStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => FJNStammdaten,
};

export enum FJNHerkunftEnum {
  FJN_FRANKFURT = 'FJN_FRANKFURT',
  FJN_RHEINMAIN = 'FJN_RHEINMAIN',
  FJN_MORE_THAN_25 = 'FJN_MORE_THAN_25',
  FJN_MORE_THAN_50 = 'FJN_MORE_THAN_50',
}
registerEnum({ enum: FJNHerkunftEnum, name: 'FJNHerkunftEnum' });

@Entity()
export class FJNStammdaten extends UserStammdaten {
  static override _class = 'FJNStammdaten';

  override getTranslationNamespace() {
    return 'fjn';
  }

  @Field(type => String)
  degree: Maybe<string>;

  @Field(type => String)
  fach: Maybe<string>;

  @Field(type => Int)
  age: Maybe<number>;

  @Field(type => FJNHerkunftEnum)
  herkunft: Maybe<FJNHerkunftEnum>;
}
